module.exports = __webpack_public_path__ + "img/day12.40be8e5b.jpeg";